module.exports = __webpack_public_path__ + "img/support.cabc8eb4.svg";